import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addProductToPO, initializePurchaseOrderProductList } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { initializePOProductForm, loadPOProductItem, clearFormInput } from 'actions/FormActions';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import { selectPOProductModel } from 'selectors/entitySelector';
import util from 'library/util';
import { Link } from 'react-router-dom';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import RadioInput from 'screens/components/basic/RadioInput';
import 'styles/po.css';
import DecimalInputOnePlace from 'screens/components/basic/DecimalInputOnePlace';

class POProductSave extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: []
        }
        this.list = [];
    }

    componentWillMount() {
        this.props.init(this.props.name);
        this.props.initProductList();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.productListLength !== this.props.productListLength && newProps.productListLength != null && newProps.productListLength != undefined) {
            let arrayOfProduct = newProps.products.filter(c => c.status === "Active");
            let slectionList = [];
            if (newProps.searchMethod === "sku") {
                slectionList = this.loadSKUList(arrayOfProduct);
            }
            else {
                slectionList = this.loadList(arrayOfProduct);
            }
            this.setState({
                productList: slectionList
            });
        }

        if (newProps.selectedProduct) {
            if (this.props.selectedProduct !== newProps.selectedProduct) {
                this.props.loadForm(this.props.name, newProps.selectedProduct, this.props.products);
            }
        }

        if (this.props.searchMethod != newProps.searchMethod && newProps.searchMethod != null && newProps.searchMethod != undefined) {
            let activeProducts = this.props.products ? this.props.products.filter(p => p.status === "Active") : [];
            let slectionList = [];
            if (newProps.searchMethod === "sku") {
                slectionList = this.loadSKUList(activeProducts);
            }
            else {
                slectionList = this.loadList(activeProducts);
            }
            this.setState({
                productList: slectionList
            });
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput('productPOSearchMethod');
    }

    addProduct = () => {
        const p = this.props;
        const validators = [
            [p.name + 'Id', product => (product.productId !== 0), "Product"],
            [p.name + 'Quantity', product => product.quantity > 0, "Quantity"]
        ];

        let product = this.props.productModel;
        const productAlreadyAdded = this.props.productListPO.find((item) => { return item.productId === product.productId });
        if (!productAlreadyAdded) {
            if (util.validate(validators, product, this.props.formError)) {
                this.props.addProduct(product);
                this.props.callListView();
                this.clearForm();
            }
        }
        else {
            this.props.showError("Product already added as an Item for this Purchase Order.");
        }
    }

    clearForm = () => {
        this.props.clearFormInput('productPOTotalPrice');
        this.props.clearFormInput('productPOUnitPrice');
        this.props.clearFormInput('productPOName');
        this.props.clearFormInput('productPOSku');
    }

    loadList = (products = []) => {
        this.list = [];
        products.map((product) => {
            this.list.push(
                { text: product.name, value: parseInt(product.id), id: parseInt(product.id) }
            );
        });
        return this.list;
    }

    loadSKUList = (products = []) => {
        this.list = [];
        products.map((product) => {
            this.list.push(
                { text: product.sku, value: parseInt(product.id), id: parseInt(product.id) }
            );
        });
        return this.list;
    }

    render() {
        let p = this.props;
        let activeProducts = this.state.productList;
        let searchMethods = [{
            text: "Name",
            value: "name"//1
        }, {
            text: "SKU",
            value: "sku"
        }]

        return (
            <div>
                <div className="row mb-1">
                    <div className="col-xs-12">
                        <RadioInput
                            title="Search Method"
                            groupName={`${p.name}SearchMethod`}
                            options={searchMethods}
                            className="inline-radio-btns"
                            fullWidth={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 mt_-20">
                        <AutoCompleteInput
                            methodName={`${p.name}SearchMethod`}
                            name={`${p.name}Id`}
                            label={this.props.searchMethod == "sku" ? "Search an existing product by SKU" : "Search an existing product by Name"}
                            hintText="Product"
                            className="AutoCompleteInput-searchbar"
                            options={activeProducts} 
                            required
                        />
                        {this.props.canAddEditProduct &&
                            <div className="row">
                                <div className="col-xs-12 p-0">
                                    <Link
                                        className="link-new-above"
                                        onClick={() => this.props.openProductForm()}>Create new Product</Link>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-lg-3 mt_-20">
                        {
                            this.props.searchMethod == "sku" ?
                                <TextInput
                                    name={`${p.name}Name`}
                                    fullWidth={true}
                                    label={LOOKUP.product.name.label}
                                    hintText={LOOKUP.product.name.label}
                                    floatingLabelText={LOOKUP.product.name.label}
                                    disabled={true} />
                                :
                                <TextInput
                                    name={`${p.name}Sku`}
                                    fullWidth={true}
                                    label={LOOKUP.product.sku.label}
                                    hintText={LOOKUP.product.sku.label}
                                    floatingLabelText={LOOKUP.product.sku.label}
                                    disabled={true} />
                        }
                    </div>
                    <div className="col-lg-3 mt_-20">
                        <TextInput
                            name={`${p.name}Category`}
                            fullWidth={true}
                            label={LOOKUP.product.category.label}
                            hintText={LOOKUP.product.category.label}
                            floatingLabelText={LOOKUP.product.category.label}
                            disabled={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4">
                        {
                            this.props.isMedical ?
                                <DecimalInputOnePlace name={`${p.name}Quantity`}
                                    type="number"
                                    fullWidth={true}
                                    label={LOOKUP.product.quantity.label}
                                    floatingLabelText={LOOKUP.product.quantity.label}
                                    hintText={"Quantity"}
                                    min={0}
                                    max={100000} />
                                :
                                <TextInput name={`${p.name}Quantity`}
                                    type="number"
                                    fullWidth={true}
                                    label={LOOKUP.product.quantity.label}
                                    floatingLabelText={LOOKUP.product.quantity.label}
                                    hintText={"Quantity"}
                                    min={0}
                                    max={100000} />
                        }
                    </div>
                    <div className="col-lg-4">
                        <DecimalInput
                            name={`${p.name}UnitPrice`}
                            fullWidth={true}
                            id="productPOUnitPrice"
                            label={LOOKUP.purchaseOrder.unitPrice.label}
                            hintText={LOOKUP.purchaseOrder.unitPrice.hintText}
                            floatingLabelText={LOOKUP.purchaseOrder.unitPrice.label}
                            min={0}
                            max={100000} />
                    </div>
                    <div className="col-lg-4">
                        <DecimalInput
                            name={`${p.name}TotalPrice`}
                            fullWidth={true}
                            label={LOOKUP.purchaseOrder.totalPrice.label}
                            hintText={LOOKUP.purchaseOrder.totalPrice.hintText}
                            floatingLabelText={LOOKUP.purchaseOrder.totalPrice.label}
                            min={0}
                            max={100000} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Button
                            name="addButton"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.product.controls.addButton}
                            primary={true}
                            onTouchTap={this.addProduct} />
                        <Button
                            type="CancelButton"
                            name="cancelButton"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.vendor.controls.cancelButton}
                            onTouchTap={p.cancelAddProduct} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        canAddEditProduct: state.common.authenticatedUser && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanAddEditProduct")),
        productModel: selectPOProductModel(state, props.name),
        products: state.entity.productList,
        productListPO: state.entity.productListPO,
        selectedProduct: state.form[props.name + "Id"] ? parseInt(state.form[props.name + "Id"]) : '',
        branchId: state.common.branchId,
        productListLength: state.entity.productListLength,
        searchMethod: state.form[props.name + "SearchMethod"],
        searchText: state.form["POProductsaveSearchText"],
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addProduct: (model) => dispatch(addProductToPO(model)),
        init: (name) => dispatch(initializePOProductForm(name)),
        initProductList: () => dispatch(initializePurchaseOrderProductList()),
        loadForm: (name, productId, products) => dispatch(loadPOProductItem(name, productId, products)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(POProductSave);
